import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './CollaborationChat.css';

const CollaborationChat = () => {
  const { token } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    console.log('═══════════════════════════════════════');
    console.log('🤝 COLLABORATION CHAT COMPONENT');
    console.log('🔗 Token from URL:', token);

    // Check if user is authenticated (using 'token' not 'authToken')
    const authToken = localStorage.getItem('token');
    console.log('🔐 Auth token exists:', !!authToken);

    if (!authToken) {
      console.log('❌ NOT AUTHENTICATED - Redirecting to login');
      console.log('🔄 Will return to: /collaborate/' + token);
      console.log('═══════════════════════════════════════');
      // Store the collaboration token in localStorage
      localStorage.setItem('pendingCollabToken', token);
      // Redirect to login with return URL
      navigate(`/login?returnUrl=/collaborate/${token}`, { replace: true });
    } else {
      console.log('✅ AUTHENTICATED - Processing collaboration');
      // User is authenticated, redirect to dashboard with the shared chat
      localStorage.setItem('openCollabChat', token);
      const stored = localStorage.getItem('openCollabChat');
      console.log('💾 Stored openCollabChat in localStorage:', stored);
      console.log('🎯 Redirecting to /dashboard');
      console.log('═══════════════════════════════════════');

      // Force a small delay before redirecting to ensure storage completes
      setTimeout(() => {
        window.location.href = '/dashboard';
      }, 200);
    }
  }, [token, navigate]);

  return (
    <div className="collab-container">
      <div className="collab-loading">Redirecting to login...</div>
    </div>
  );
};

export default CollaborationChat;
